import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import ProductDetail from "@/pages/ProductDetail";
import Checkout from "@/pages/Checkout";
import Navbar from "@/components/Navbar";
import { CartProvider } from "@/context/CartContext";
import { AdminProvider } from "@/context/AdminContext";
import ProtectedRoute from "@/components/admin/ProtectedRoute";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminCoupons from "@/pages/admin/AdminCoupons";
import AdminReviews from "@/pages/admin/AdminReviews";
import AdminUpsell from "@/pages/admin/AdminUpsell";
import axios from "axios";
import { getApiUrl } from "@/utils/api";

const API = getApiUrl();

// Component to track page visits
const VisitorTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Only track public pages (not admin)
    if (!location.pathname.startsWith('/admin')) {
      axios.post(`${API}/track-visit`, {
        page: location.pathname,
        referrer: document.referrer || null
      }).catch(() => {
        // Silently fail
      });
    }
  }, [location.pathname]);

  return null;
};

function App() {
  return (
    <AdminProvider>
      <CartProvider>
        <div className="App">
          <BrowserRouter>
            <VisitorTracker />
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<><Navbar /><Home /></>} />
              <Route path="/catalog" element={<><Navbar /><Catalog /></>} />
              <Route path="/product/:id" element={<><Navbar /><ProductDetail /></>} />
              <Route path="/checkout" element={<><Navbar /><Checkout /></>} />
              
              {/* Admin Routes */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
              <Route path="/admin/products" element={<ProtectedRoute><AdminProducts /></ProtectedRoute>} />
              <Route path="/admin/orders" element={<ProtectedRoute><AdminOrders /></ProtectedRoute>} />
              <Route path="/admin/coupons" element={<ProtectedRoute><AdminCoupons /></ProtectedRoute>} />
              <Route path="/admin/reviews" element={<ProtectedRoute><AdminReviews /></ProtectedRoute>} />
              <Route path="/admin/upsell" element={<ProtectedRoute><AdminUpsell /></ProtectedRoute>} />
            </Routes>
            <Toaster position="top-right" theme="dark" toastOptions={{ style: { zIndex: 9999 } }} />
          </BrowserRouter>
        </div>
      </CartProvider>
    </AdminProvider>
  );
}

export default App;